import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CryptoJS from 'crypto-js';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CustomerAvatar = ({ className, customerName, selectedAccountId, accounts }) => {
  const accountDescription = () => {
    const selectedAccount = accounts != null ? accounts.filter(x => x.id === selectedAccountId) : null;
    return selectedAccount && selectedAccount.length === 1 ? selectedAccount[0].displayName : '';
  };

  return (<React.Fragment>
    { customerName != null && <div className={ `avatar ${ className !== null ? className : 'desktop-username' } col-md-10` }>
      <div className="row m-0 tooltip">
        <span className="text-left"><FontAwesomeIcon icon="user-circle" size="lg" /></span>
        <div className="col-10">
          <h3 className="text-left pr-0">{ customerName }</h3>
          { selectedAccountId > 0 && <h4>ACC: { accountDescription() }</h4> }
        </div>
        <span className="tooltiptext">{ `${ customerName } - ${ selectedAccountId > 0 ? accountDescription() : '' }` }</span>
      </div>
    </div> }
  </React.Fragment>);
};

CustomerAvatar.propTypes = {
  className: PropTypes.string,
  customerName: PropTypes.string,
  selectedAccountId: PropTypes.number,
  accounts: PropTypes.arrayOf(PropTypes.shape())
};

CustomerAvatar.defaultProps = {
  className: null,
  customerName: null,
  selectedAccountId: null,
  accounts: null
};

function mapStateToProps(state) {
  const {
    app: {
      onlineConfig,
      customerData,
      key
    },
    form: {
      selectedAccountId
    }
  } = state;

  const decryptedArray = customerData ? CryptoJS.AES.decrypt(customerData, key) : null;
  const decryptedText = decryptedArray ? decryptedArray.toString(CryptoJS.enc.Utf8) : null;
  const customerDetails = decryptedText ? JSON.parse(decryptedText) : null;

  return {
    customerName: customerDetails && customerDetails.CustomerName,
    selectedAccountId,
    accounts: onlineConfig?.customer != null ? onlineConfig.customer.accounts : null
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerAvatar);
